/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage, FormattedNumber } from 'react-intl';
import Field from 'redux-form/es/Field';
import Slider from 'components/Credit24/LoanApplication/OfferDetails/Slider';
import InputSelectField from 'components/Credit24/Core/Controls/InputSelectField';
import { fromCents, getCurrencyCode } from 'utils/helpers';

const propTypes = {
  loan: PropTypes.object.isRequired,
  principalIndex: PropTypes.number,
  firstDrawAmountIndex: PropTypes.number,
  creditLimits: PropTypes.array,
};

const OcmProduct = (props) => {
  const {
    loan,
    principalIndex = Number.MAX_SAFE_INTEGER,
    firstDrawAmountIndex = Number.MAX_SAFE_INTEGER,
    creditLimits,
  } = props;
  const {
    productType,
    availableProducts,
    availablePrincipalsIndex = [],
  } = loan;
  const isProductTypeInstallment = productType === 'INSTALLMENT';
  let isSubstituteInstallmentLoan = false;
  if (!PRODUCT_IL && !INCREASE_APP) {
    isSubstituteInstallmentLoan = isProductTypeInstallment;
  }

  const maxPrincipalIndex = availablePrincipalsIndex.length - 1;
  const productPrincipalIndex = Math.min(principalIndex, maxPrincipalIndex);
  const product = availableProducts[availablePrincipalsIndex[productPrincipalIndex]];

  const totalBalanceRepaymentPeriodInMonths = product.totalBalanceRepaymentPeriodInMonths;

  const { firstDrawAmountIndexes } = product;
  let secondaryProducts = product.withdraws;

  let theme = null;
  if (isProductTypeInstallment) {
    secondaryProducts = product.productOffers;
    theme = 'maturity';
  }
  const maxFirstdrawAmountIndex = firstDrawAmountIndexes.length - 1;
  const firstDrawIndex = Math.min(firstDrawAmountIndex, maxFirstdrawAmountIndex);
  const { minimumPayment } = secondaryProducts[firstDrawAmountIndexes[firstDrawIndex]];

  const isValueSelected = PRODUCT_IL || isSubstituteInstallmentLoan || principalIndex >= 0;

  return (
    <div className="loan-form__step txt-center">
      <h1 className="loan-form__step-title txt-center">
        <FormattedMessage id="offer.title.ocm" />
      </h1>
      <div className="loan-form__step-body">
        <div className="grid grid--center">
          <div className="grid__item one-whole">
            <div className="message message--offer">
              <div className="message__content">
                <FormattedMessage id="offer.maximum.ocm" />
              </div>
              <div className="message__value">
                <FormattedNumber
                  minimumFractionDigits={0}
                  maximumFractionDigits={0}
                  currency={getCurrencyCode()}
                  style="currency"
                  value={fromCents(availablePrincipalsIndex[maxPrincipalIndex])}
                />
              </div>
            </div>
            <div className="offer-details">
              <div className="offer-details__item offer-details__item--large">
                <h3 className="txt-left txt-muted">
                  <FormattedMessage id="offer.ocm.principal.title" />
                </h3>
                <div className="padding-bottom--20">
                  <Field
                    emptyTextKey="offer.CREDIT_LINE.credit_limit_title"
                    name="principalIndex"
                    component={InputSelectField}
                    options={creditLimits}
                    isFullWidth
                  />
                </div>
                <h3 className="txt-left txt-muted">
                  <FormattedMessage id="offer.ocm.loanBalance.title" />
                </h3>
                <div className="offer-details__amount padding-bottom--20">
                  <FormattedNumber
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                    currency={getCurrencyCode()}
                    style="currency"
                    value={fromCents(loan.legacyBalance)}
                  />
                </div>
                <h3 className="txt-left txt-muted">
                  <FormattedMessage id="offer.ocm.creditBalance.title" />
                </h3>
                <div className="offer-details__amount padding-bottom--20">
                  <FormattedNumber
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                    currency={getCurrencyCode()}
                    style="currency"
                    value={fromCents(availablePrincipalsIndex[principalIndex] - loan.legacyBalance)}
                  />
                </div>
                <h3 className="txt-left txt-muted">
                  <FormattedMessage id="offer.ocm.firstDrawAmount.title" />
                </h3>
                <Slider
                  name="firstDrawAmountIndex"
                  maxValue={maxFirstdrawAmountIndex}
                  minValue={0}
                  step={1}
                  defaultValue={firstDrawIndex}
                  availablePrincipalsIndex={firstDrawAmountIndexes}
                  productType={`${productType}_firstDrawAmount`}
                  theme={theme}
                />
              </div>
              {isValueSelected
                && (
                  <div className="offer-details__item offer-details__item--small">
                    <div className="offer-details__amount">
                      <FormattedNumber
                        minimumFractionDigits={2}
                        maximumFractionDigits={2}
                        currency={getCurrencyCode()}
                        style="currency"
                        value={fromCents(minimumPayment)}
                      />
                    </div>
                    <div className="offer-details__label txt-muted padding-bottom--20">
                      <FormattedHTMLMessage
                        id="offer.ocm.mmp.minimumRepay"
                        values={{
                          amount: totalBalanceRepaymentPeriodInMonths,
                        }}
                      />
                    </div>
                    <div className="offer-details__label txt-muted">
                      <p>
                        <FormattedMessage id="offer.ocm.apr.label" />
                      </p>
                    </div>
                    <div className="offer-details__amount padding-bottom--20">
                      {product.apr}
                      %
                    </div>
                    <div className="offer-details__label txt-muted">
                      <p>
                        <FormattedMessage id="offer.ocm.annualInterest.label" />
                      </p>
                    </div>
                    <div className="offer-details__amount">
                      {product.annualInterest}
                      %
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

OcmProduct.propTypes = propTypes;

export default OcmProduct;
